import React, { useEffect, useState } from "react";
import { Spin, Table } from "antd";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-daterangepicker/daterangepicker.css";
import SidebarNav from "../sidebar";
import { Link } from "react-router-dom";
import { addEdd, getUser } from "../../../service/api";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import actions from "../../../redux/user/actions";
import CustomPagination from "../Pagination/pagination";
import FilterPanel from "../commoncomponent/FilterPanel";
import TableToolbar from "../commoncomponent/TableToolbar";
import { useTableSettings } from "../../../hooks/useTableSettings";
import DateRangePicker from "react-bootstrap-daterangepicker";
import Select from "react-select";
import moment from "moment";
import { Box, Fade, Modal } from "@mui/material";
import { sanitizeInput } from "../../../config/validation";
import { triggerDownload } from "../../../config/downloadUtils";

const formatDateTime = (val) =>
  val ? moment(val).format("DD/MM/YYYY HH:mm") : "-";

const riskLabel = (score) => {
  if (score === undefined || score === null || score === "") return "-";
  if (score > 7) return "High Risk";
  if (score < 4) return "Low Risk";
  return "Medium Risk";
};

const ALL_COLUMNS = [
  {
    key: "user",
    title: "User",
    defaultVisible: true,
    render: (r) => `${r?.firstName ?? ""} ${r?.lastName ?? ""}`.trim() || "-",
  },
  {
    key: "email",
    title: "Email",
    defaultVisible: true,
    render: (r) => r?.email || "-",
  },
  {
    key: "phoneNumber",
    title: "Phone Number",
    defaultVisible: true,
    render: (r) => r?.phoneNumber || "-",
  },
  {
    key: "kycRetryCount",
    title: "KYC Count",
    defaultVisible: true,
    render: (r) =>
      r?.kycRetryCount !== undefined && r?.kycRetryCount !== null
        ? r.kycRetryCount
        : "-",
  },
  {
    key: "riskAssessment",
    title: "Risk Assessment",
    defaultVisible: true,
    render: (r) => riskLabel(r?.riskAssessment?.score),
  },
  {
    key: "riskScore",
    title: "Risk Score",
    defaultVisible: false,
    render: (r) =>
      r?.riskAssessment?.score !== undefined &&
      r?.riskAssessment?.score !== null
        ? r.riskAssessment.score
        : "-",
  },
  {
    key: "kycStatus",
    title: "KYC Status",
    defaultVisible: false,
    render: (r) => r?.kycStatus || "-",
  },
  {
    key: "createdAt",
    title: "Created At",
    defaultVisible: false,
    render: (r) => formatDateTime(r?.createdAt),
  },
];

const kycOptions = [
  { label: "Approved", value: "APPROVED" },
  { label: "Pending", value: "PENDING" },
  { label: "In-progress", value: "IN-PROCESS" },
  { label: "Rejected", value: "REJECTED" },
];

const customStyles = {
  control: (base) => ({
    ...base,
    minHeight: "38px",
    height: "40px",
    width: "200px",
    minWidth: "120px",
    borderRadius: "4px",
    border: "1px solid #ced4da",
    fontSize: "14px",
    padding: "0px 4px",
    backgroundColor: "#fff",
  }),
  dropdownIndicator: (base) => ({
    ...base,
    padding: "4px",
  }),
  indicatorSeparator: () => ({ display: "none" }),
};

const Alert = () => {
  const [userList, setUserlist] = useState([]);
  const [loading, setLoading] = useState(false);
  const [downloadLoading, setDownloadLoading] = useState(false);
  const dispatch = useDispatch();
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  const [page, setPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState("");
  const [kyc, setKyc] = useState();
  const [imageModalVisible, setImageModalVisible] = useState(false);
  const [modalImages, setModalImages] = useState([]);
  const [modalTitle, setModalTitle] = useState("");

  const {
    pageSize,
    setPageSize,
    pageSizeOptions,
    visibleColumnKeys,
    toggleColumn,
    resetColumns,
    dynamicColumns,
  } = useTableSettings({
    storageKey: "alert-list",
    allColumns: ALL_COLUMNS,
  });

  const getUserList = () => {
    let body = {
      page: page,
      sizePerPage: pageSize,
      pagination: true,
      alert: true,
    };
    if (searchTerm) {
      body.search = searchTerm;
    }
    if (kyc) {
      body.kycStatus = kyc?.value;
    }
    if (startDate) {
      body.startDate = startDate;
    }
    if (endDate) {
      body.endDate = endDate;
    }

    setLoading(true);
    getUser(body)
      .then((res) => {
        if (res?.status) {
          setUserlist(res?.data);
          dispatch(actions.setUserList(res?.data?.result));
        }
        setLoading(false);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleDownload = (format) => {
    const body = { pagination: false, alert: true };
    if (searchTerm) body.search = searchTerm;
    if (kyc) body.kycStatus = kyc?.value;
    if (startDate) body.startDate = startDate;
    if (endDate) body.endDate = endDate;
    setDownloadLoading(true);
    getUser(body)
      .then((res) => {
        const result = res?.data?.result ?? [];
        if (!result.length) { toast.warning("Nothing to download", { toastId: 'nothing-to-download' }); return; }
        const cols = ALL_COLUMNS.filter((c) => visibleColumnKeys.includes(c.key));
        triggerDownload(format, result, cols, "alert-users");
      })
      .finally(() => setDownloadLoading(false));
  };

  useEffect(() => {
    getUserList();
  }, [page, pageSize, startDate, endDate, searchTerm, kyc]);

  // Reset to page 1 whenever filters or page size change.
  useEffect(() => {
    setPage(1);
  }, [pageSize, startDate, endDate, searchTerm, kyc]);

  const handleDateRangeChange = (event, picker) => {
    setStartDate(picker.startDate.format("YYYY-MM-DD"));
    setEndDate(picker.endDate.format("YYYY-MM-DD"));
  };

  const columns2 = [...dynamicColumns];

  return (
    <>
      <SidebarNav />
      <div className="page-wrapper">
        <div className="content container-fluid">
          {/* Page Header */}
          <div className="page-header">
            <div className="row">
              <div className="col-sm-7 col-aut0">
                <h3 className="page-title">Alert User</h3>
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/admin">Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item active">Alert User</li>
                </ul>
              </div>
              <div className="col-sm-5 col"></div>
            </div>
          </div>

          {/* /Page Header */}
          <div className="list-layout">
            <div className="list-layout__main">
              <div className="card">
                <div className="card-body">
                  <TableToolbar
                    pageSize={pageSize}
                    setPageSize={setPageSize}
                    pageSizeOptions={pageSizeOptions}
                    total={userList?.total}
                    page={page}
                    visibleColumnKeys={visibleColumnKeys}
                    allColumns={ALL_COLUMNS}
                    toggleColumn={toggleColumn}
                    resetColumns={resetColumns}
                    onDownload={handleDownload}
                    downloadLoading={downloadLoading}
                  />
                  <div className="table-responsive">
                    {loading ? (
                      <div className="his-spin">
                        <Spin
                          size="large"
                          style={{ position: "relative", top: "35%" }}
                        />
                      </div>
                    ) : (
                      <Table
                        pagination={false}
                        style={{ overflowX: "auto" }}
                        columns={columns2}
                        dataSource={userList ? userList?.result : []}
                        rowKey={(record) => record._id || record.id}
                      />
                    )}
                    {userList && userList?.total > pageSize && (
                      <CustomPagination
                        key={`pg-${pageSize}`}
                        totalTabs={userList?.total}
                        tabsPerPage={pageSize}
                        handleChange={setPage}
                        className={`${
                          loading ? "display-hide" : "display-flex"
                        }`}
                      />
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div className="list-layout__filters">
              <FilterPanel
                count={userList?.total}
                onClear={() => {
                  setSearchTerm("");
                  setKyc(null);
                  setStartDate();
                  setEndDate();
                }}
              >
                <FilterPanel.Field label="Search">
                  <input
                    type="text"
                    placeholder="Name or email"
                    value={searchTerm}
                    onChange={(e) =>
                      setSearchTerm(sanitizeInput(e.target.value))
                    }
                  />
                </FilterPanel.Field>
                <FilterPanel.Field label="KYC Status">
                  <Select
                    options={kycOptions}
                    value={kyc || null}
                    onChange={(option) => setKyc(option)}
                    styles={customStyles}
                    placeholder="Any"
                    isClearable
                  />
                </FilterPanel.Field>
                <FilterPanel.Field label="Date Range">
                  <DateRangePicker
                    onApply={handleDateRangeChange}
                    isClearable={true}
                  >
                    <input
                      type="text"
                      placeholder="Select date range"
                      readOnly
                    />
                  </DateRangePicker>
                </FilterPanel.Field>
              </FilterPanel>
            </div>
          </div>
        </div>
        <Modal
          aria-labelledby="transition-modal-title"
          aria-describedby="transition-modal-description"
          open={imageModalVisible}
          onClose={() => setImageModalVisible(false)}
          closeAfterTransition
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            p: 2,
          }}
        >
          <Fade in={imageModalVisible}>
            <Box
              sx={{
                width: {
                  xs: "95vw",
                  sm: 400,
                  md: 600,
                  lg: 700,
                },
                maxWidth: "98vw",
                bgcolor: "background.paper",
                borderRadius: 2,
                boxShadow: 24,
                p: 2,
                outline: "none",
                maxHeight: "90vh",
                overflowY: "auto",
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  marginBottom: 16,
                }}
              >
                <div style={{ fontWeight: 600, fontSize: 18 }}>
                  {modalTitle || "EDD Documents"}
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  gap: 16,
                  justifyContent: "center",
                }}
              >
                {modalImages && modalImages.length > 0 ? (
                  modalImages.map((file, idx) => (
                    <div
                      key={idx}
                      style={{
                        marginBottom: 12,
                        textAlign: "center",
                        flex: "1 1 140px",
                        minWidth: 140,
                        maxWidth: 200,
                        width: "100%",
                        boxSizing: "border-box",
                        cursor: "pointer",
                      }}
                    >
                      <div
                        style={{
                          fontSize: 12,
                          marginBottom: 4,
                          wordBreak: "break-all",
                        }}
                      >
                        {file.label}
                      </div>
                      {file?.type === "image" ? (
                        <img
                          src={file?.url}
                          alt={`EDD Doc ${idx + 1}`}
                          draggable="false"
                          onContextMenu={(e) => e.preventDefault()}
                          style={{
                            width: "100%",
                            height: "auto",
                            maxWidth: 200,
                            maxHeight: 200,
                            borderRadius: 8,
                            border: "1px solid #eee",
                            objectFit: "contain",
                          }}
                        />
                      ) : (
                        <video
                          src={file?.url}
                          controls
                          style={{
                            width: "100%",
                            height: "auto",
                            maxWidth: 200,
                            maxHeight: 200,
                            borderRadius: 8,
                            border: "1px solid #eee",
                            objectFit: "contain",
                          }}
                        />
                      )}
                    </div>
                  ))
                ) : (
                  <span>No images found.</span>
                )}
              </div>
            </Box>
          </Fade>
        </Modal>
      </div>
    </>
  );
};

export default Alert;
